import React, { useState } from "react"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import PostCard from "../components/blog/PostCard"
import Button from "../components/Button"

import firstPostImg from "../images/blog/first.png"
import secondPostImg from "../images/blog/second.png"
import thirdPostImg from "../images/blog/third.png"
import fourthPostImg from "../images/blog/fourth.png"
import fifthPostImg from "../images/blog/fifth.png"
import sixthPostImg from "../images/blog/sixth.png"

import InLineIcon from "../images/in-line.svg"
import SeveralInRowIcon from "../images/several-in-row.svg"

const posts = [
  {
    imgUrl: firstPostImg,
    title: "Ut enim ad minim veniam",
    date: "February 24, 2019",
    path: "ut-enim-ad-minim-veniam",
    excerpt:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  },
  {
    imgUrl: secondPostImg,
    title: "Quis ipsum suspendisse",
    date: "May 12, 2019",
    path: "quis-ipsum-suspendisse",
    excerpt:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  },
  {
    imgUrl: thirdPostImg,
    title: "Labore et dolore magna",
    date: "February 24, 2019",
    path: "labore-et-dolore-magna",
    excerpt:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  },
  {
    imgUrl: fourthPostImg,
    title: "Ut enim ad minim veniam",
    date: "February 24, 2019",
    path: "ut-enim-ad-minim-veniam",
    excerpt:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  },
  {
    imgUrl: fifthPostImg,
    title: "Quis ipsum suspendisse",
    date: "May 12, 2019",
    path: "quis-ipsum-suspendisse",
    excerpt:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  },
  {
    imgUrl: sixthPostImg,
    title: "Labore et dolore magna",
    date: "February 24, 2019",
    path: "labore-et-dolore-magna",
    excerpt:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  },
]

const Blog = () => {
  const [typeElements, setTypeElements] = useState("grid") // grid or list

  return (
    <Layout>
      <Seo title="blog" />

      <section>
        <h1 className="text-center font-playfair text-[70px] font-black text-black mb-[35px] mt-[66px]">
          Blog
        </h1>

        <div className="desktop flex justify-between items-center mb-[17px]">
          <p className="flex items-center m-0 font-ubuntu text-black font-light text-[16px] cursor-pointer">
            Popular post
            <StaticImage
              className="ml-[5px]"
              src="../images/blog-select.svg"
              quality={95}
              formats={["auto", "webp", "avif"]}
              alt="select"
              loading="lazy"
            />
          </p>

          <div className="flex">
            <button className="bg-transparent border-none">
              <img
                onClick={() => setTypeElements("list")}
                className={`m-0 cursor-pointer opacity-30 ${
                  typeElements === "list" ? "opacity-100" : null
                }`}
                src={InLineIcon}
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt="in-line"
                loading="lazy"
              />
            </button>

            <button className="bg-transparent border-none">
              <img
                onClick={() => setTypeElements("grid")}
                className={`m-0 ml-[11px] cursor-pointer opacity-30 ${
                  typeElements === "grid" ? "opacity-100" : null
                }`}
                src={SeveralInRowIcon}
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt="several in a row"
                loading="lazy"
              />
            </button>
          </div>
        </div>

        <div className="bg-blog pt-[100px]">
          <div className="desktop flex flex-wrap w-full justify-between">
            {posts.map(post => (
              <PostCard type={typeElements} post={post} key={post.imgUrl} />
            ))}

            <div className="flex w-full justify-center">
              <Button size="xs" styles={"mb-[100px]"}>
                Load More
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Blog
